import { Flex, Steps, Typography } from 'antd'
import { ReactNode, useMemo, useState } from 'react'

import { FormWizardContext } from './FormWizardContext'

type Data = number[]

type FormWizardStep = {
  component: ReactNode
  title?: string
}

type Props = {
  steps: FormWizardStep[]
  currentStep?: number
}

export const FormWizard = ({ steps, currentStep = 0 }: Props) => {
  const [step, setStep] = useState(currentStep)
  const [formData, setFormData] = useState<Data | null>(null)

  const handleNextStep = (data?: Data) => {
    if (step < steps.length - 1) {
      setStep((prev) => prev + 1)
    }
    if (data) {
      setFormData(data)
    }
  }

  const handlePrevStep = () => {
    if (step > 0) {
      setStep((prev) => prev - 1)
    }
  }

  const current = steps[step]

  const contextValue = useMemo(
    () => ({
      data: formData,
      currentStep: step,
      nextStep: handleNextStep,
      prevStep: handlePrevStep
    }),
    [formData, step]
  )

  return (
    <FormWizardContext.Provider value={contextValue}>
      <Flex vertical gap={20}>
        {current.title && (
          <Typography.Title level={5}>{current.title}</Typography.Title>
        )}
        <Steps
          size="small"
          current={step}
          items={steps.map(({ title }) => ({ title }))}
        />
        {current.component}
      </Flex>
    </FormWizardContext.Provider>
  )
}
